import _ from 'lodash';

import { getGa } from '../../core/googleAnalytics';

type EventAction = 'SETUP_YOUR_VENUE' | 'ONGOING_SETUP' | 'VENUE_DATA_COLLECTION_COMPLETED' | 'SAVE_AND_EXIT';

type ReportPayload = {
  eventAction: EventAction;
  eventLabel?: string;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!_.isFunction(ga)) {
    return;
  }

  ga('send', { hitType: 'event', eventCategory: 'VENUE_DATA_COLLECTION', ...payload });
};

export const reportInitialVenuesSetup = (venueName: string) =>
  report({
    eventAction: 'SETUP_YOUR_VENUE',
    eventLabel: venueName,
  });

export const reportOngoingVenueSetup = (page: string) =>
  report({
    eventAction: 'ONGOING_SETUP',
    eventLabel: page,
  });

export const reportVenueSetupCompleted = () =>
  report({
    eventAction: 'VENUE_DATA_COLLECTION_COMPLETED',
  });

export const reportSaveAndExit = (page: string) =>
  report({
    eventAction: 'SAVE_AND_EXIT',
    eventLabel: page,
  });
